// export this package's api
'use strict';

module.exports = require('./Animate');